import React from "react";

export const HeaderAd = () => {
  return (
    <div style={{ margin: "20px", textAlign: "center" }}>
      <div id="waldo-tag-9756"></div>
    </div>
  );
};

export const HeaderVideoAd = () => {
  return (
    <div style={{ margin: "20px", textAlign: "center" }}>
      <div id="waldo-tag-12143"></div>
    </div>
  );
};

export const FooterAd = () => {
  return (
    <div style={{ margin: "100px 0", textAlign: "center" }}>
      <div id="waldo-tag-9755"></div>
    </div>
  );
};
